import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withCtx as _withCtx, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_second_time_inspection",
  ref: "secondTimeInspectionRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_second_time_inspection_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-400" }, null, -1)
const _hoisted_8 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_9 = { class: "svg-icon svg-icon-1" }
const _hoisted_10 = { class: "modal-body px-17 py-9" }
const _hoisted_11 = { class: "timeline" }
const _hoisted_12 = { class: "timeline-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_14 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_15 = { class: "symbol-label bg-light" }
const _hoisted_16 = { class: "svg-icon svg-icon-1" }
const _hoisted_17 = { class: "timeline-content mb-10 mt-n1 px-3" }
const _hoisted_18 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_19 = { class: "d-flex align-items-center fs-6" }
const _hoisted_20 = { class: "fs-7 text-muted" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "overflow-auto py-5" }
const _hoisted_25 = { class: "d-flex flex-column gap-4" }
const _hoisted_26 = { class: "d-flex align-items-center gap-4" }
const _hoisted_27 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded px-3 py-7" }
const _hoisted_28 = { class: "timeline-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1)
const _hoisted_30 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_31 = { class: "symbol-label bg-light" }
const _hoisted_32 = { class: "svg-icon svg-icon-1" }
const _hoisted_33 = { class: "timeline-content mb-10 mt-n1 px-3" }
const _hoisted_34 = { class: "fs-5 fw-bold mb-1" }
const _hoisted_35 = { class: "d-flex align-items-center fs-6" }
const _hoisted_36 = { class: "fs-7 text-muted" }
const _hoisted_37 = { class: "d-flex align-items-center" }
const _hoisted_38 = { class: "svg-icon svg-icon-2x mx-1" }
const _hoisted_39 = { class: "py-5" }
const _hoisted_40 = { class: "w-100 d-flex flex-column gap-4 lh-sm" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { class: "symbol symbol-50px overflow-hidden" }
const _hoisted_43 = { class: "flex-fill mx-2" }
const _hoisted_44 = { class: "fw-bold fs-5" }
const _hoisted_45 = { class: "fs-6 text-gray-400" }
const _hoisted_46 = { class: "d-flex align-items-center" }
const _hoisted_47 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-12 form-group" }
const _hoisted_51 = { class: "form-label fw-bold" }
const _hoisted_52 = { class: "modal-footer align-items-center justify-content-end" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "indicator-label" }
const _hoisted_55 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_56 = { class: "indicator-progress" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("h2", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.inspection")) + " ", 1),
                  _createElementVNode("span", null, "/ #" + _toDisplayString(_ctx.itemData.identifier_code), 1),
                  (_ctx.itemData.order_number)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                        _createElementVNode("span", null, " / #" + _toDisplayString(_ctx.itemData.order_number), 1),
                        _createElementVNode("span", null, "#" + _toDisplayString(_ctx.itemData.position), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspect.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.itemData.__show.reason), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.t("inspection.firstTimeInspectedDate", [
                            _ctx.customFormatDateTime(_ctx.itemData.inspection_date),
                          ])), 1),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                          ]),
                          _createElementVNode("div", null, _toDisplayString(_ctx.itemData.__show.inspection_manager), 1)
                        ])
                      ])
                    ]),
                    (_ctx.formData.images.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.images, (row, rowIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "d-flex align-items-center",
                                      key: rowIndex
                                    }, [
                                      _createVNode(_component_el_image, {
                                        class: "w-200px h-100px cursor-pointer",
                                        fit: "contain",
                                        src: 
                                  row.url + '?x-oss-process=image/resize,l_200'
                                ,
                                        onClick: ($event: any) => (_ctx.previewImages(rowIndex))
                                      }, null, 8, ["src", "onClick"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, [
                        _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspect.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.t("inspection.secondTimeVisibleDefects")), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.t("inspection.plsFillSecondTimeInspectionResults")), 1),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("span", _hoisted_38, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                          ]),
                          _createElementVNode("div", null, _toDisplayString(_ctx.userInfo?.username), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_39, [
                        _withDirectives(_createVNode(_component_el_form_item, { prop: "images" }, null, 512), [
                          [_vShow, 0]
                        ]),
                        _createVNode(_component_el_form_item, { prop: "radio" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_40, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.result, (item, index) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  class: "w-100 cursor-pointer",
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["symbol-label", 
                                    _ctx.getInspectionSecondReasonBgStyleMap(
                                      Number(item.value)
                                    )
                                  ])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["svg-icon svg-icon-1", 
                                      _ctx.getInspectionSecondReasonSvgStyleMap(
                                        Number(item.value)
                                      )
                                    ])
                                        }, [
                                          _createVNode(_component_inline_svg_icon, {
                                            src: 
                                        _ctx.getInspectionSecondReasonSvgMap(
                                          Number(item.value)
                                        )
                                      
                                          }, null, 8, ["src"])
                                        ], 2)
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.getInspectionSecondReasonTitleMap(
                                      Number(item.value),
                                      _ctx.t
                                    )), 1),
                                      _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.getInspectionSecondReasonDescriptionMap(
                                      Number(item.value),
                                      _ctx.t
                                    )), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("span", _hoisted_47, [
                                        _withDirectives(_createElementVNode("input", {
                                          class: "form-check-input",
                                          type: "radio",
                                          name: "reason",
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.radio) = $event)),
                                          value: item.value
                                        }, null, 8, _hoisted_48), [
                                          [_vModelRadio, _ctx.formData.radio]
                                        ])
                                      ])
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.t("inspection.secondTimeInspectionNote")), 1),
                            _createVNode(_component_el_form_item, { prop: "notes" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formData.notes,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.notes) = $event)),
                                  type: "textarea",
                                  placeholder: _ctx.t('common.plsEnter'),
                                  clearable: ""
                                }, null, 8, ["modelValue", "placeholder"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("button", {
                type: "button",
                ref: _ctx.submitButton,
                disabled: _ctx.loading,
                class: "btn btn-lg btn-primary",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                _createElementVNode("span", _hoisted_54, [
                  _createElementVNode("span", _hoisted_55, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                ]),
                _createElementVNode("span", _hoisted_56, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                  _hoisted_57
                ])
              ], 8, _hoisted_53)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}